export const AUTO_NAVIG_WINDOW_NAME = "efb-auto-navig";

/** FlightIds whose FIRST nav log arrived, in op order. A flight create writes it
 *  (`initNav`) after the route, so the route is complete when it lands.
 *  A recomputed nav log carries a higher `revision`, so an edit, or a flight
 *  whose first nav log was missed, never counts as new. */
export function firstNavFlightIds(ops: readonly { type?: string; row: Record<string, unknown> }[]): string[] {
  const found: string[] = [];
  for (const op of ops) {
    if (op.type !== undefined && op.type !== "upsert") continue;
    const raw = op.row?.["flightId"];
    if (raw === undefined || raw === null || raw === "") continue;
    if (Number(op.row["revision"]) !== 1) continue;
    if (op.row["obsolete"] === 1 || op.row["obsolete"] === "1") continue;
    const id = String(raw);
    if (!found.includes(id)) found.push(id);
  }
  return found;
}
